export default __webpack_public_path__ + "static/media/er.31a06190.svg";